import {AppleSSOButton} from "./AppleSSOButton";
import {FacebookLoginButton} from "./FacebookLoginButton";
import React from "react";
import {Stack} from "@chakra-ui/react";

/**
 * Component to house the Social Login buttons.
 * @param next - The URL that all of the social providers should redirect too. Can be overridden by the provider
 *  specific next param.
 * @param facebookNext - The URL to be redirected to for Facebook login.
 * @param facebookButtonProps - Extra props to be passed to the FacebookLoginButton.
 * @param showFacebook - Whether or not to show the Facebook button. When true, Facebook still has to be configured or
 *  it still won't display.
 * @param appleNext - the URL to be redirected to for Apple login.
 * @param appleButtonProps - Extra props to be passed to the AppleSSOButton.
 * @param showApple - Whether or not to show the Apple button. When true, Apple still has to be configured or it
 *  still won't display.
 * @constructor
 */
export const SocialLogin = ({
                                next,
                                facebookNext,
                                facebookButtonProps,
                                showFacebook=true,
                                appleNext,
                                appleButtonProps,
                                showApple=true,
                            }) => {

    return (
        <Stack spacing={2}>
            {showFacebook && <FacebookLoginButton
                next={facebookNext || next}
                {...facebookButtonProps}
            />}
            {showApple && <AppleSSOButton
                next={appleNext || next}
                {...appleButtonProps}
            />}
        </Stack>
    );
};
